/**
 * Class defining promotions information data descriptors.
 *
 * @class PromotionsDataDescriptors
 * @name descriptor
 * @memberof Mojito.Services.Promotions
 */
export default class PromotionsDataDescriptors {
    /**
     * Factory method for creating a promotions data descriptor.
     *
     * @param {Array<string>} channels - Promotions channels to subscribe.
     *
     * @returns {{dataType: string, channels: string}} Promotions data descriptor.
     *
     * @function Mojito.Services.Promotions.descriptor#createPromotionsDescriptor
     * @static
     */
    static createPromotionsDescriptor(channels) {
        return {
            dataType: PromotionsDataDescriptors.DATA_TYPES.PROMOTIONS,
            channels,
        };
    }
}

/**
 * Promotions unique data descriptor types.
 *
 * @typedef DATA_TYPES
 * @property {string} PROMOTIONS - Descriptor type for the promotions.
 *
 * @memberof Mojito.Services.Promotions.descriptor
 */
PromotionsDataDescriptors.DATA_TYPES = {
    PROMOTIONS: 'promotions',
};
